import { EntityState } from '@ngrx/entity';
import { ErrorResponse } from '~shared/modules/error-handler';
import { orderHistoryAdapter } from './orders-history-list.adapter';
import { OrderHistoryItem } from '../../models';

export interface OrdersHistoryState extends EntityState<OrderHistoryItem> {
  totalCount: number;
  error: ErrorResponse | null;
  loading: boolean;
}

export const initialOrdersHistoryState: OrdersHistoryState = orderHistoryAdapter.getInitialState({
  totalCount: 0,
  error: null,
  loading: false,
});
